module.exports = __webpack_public_path__ + "img/rupee-sign.13585b67.svg";